
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import { FileLikeObject } from 'ng2-file-upload/file-upload/file-like-object.class';
import { NotificationsService } from 'angular2-notifications';


declare var $: any;

@Component({
    selector: 'app-upload',
    templateUrl: 'upload.component.html',
    styleUrls: ['upload.component.css']
})
export class KbUploadComponent implements OnInit {

    get url() {
        return this._url;
    }

    @Input('url')
    set columns(newValue: any) {
        this._url = newValue;
        this.uploader.setOptions({ url: this._url, authToken: 'Bearer elToken' });
    }

    @Input() autoUpload = true;

    @Output() onSuccess: EventEmitter<any> = new EventEmitter();
    @Output() onError: EventEmitter<any> = new EventEmitter();
    @Output() onCancel: EventEmitter<any> = new EventEmitter();
    @Output() onAddingFileFailed: EventEmitter<any> = new EventEmitter();
    @Output() onAfterAdding: EventEmitter<any> = new EventEmitter();
    @Output('valueChange') valueChange = new EventEmitter<any>();

    uploading = false;
    hasFileOver = false;
    uploader: FileUploader = new FileUploader({});
    _url: string = null;
    texto1: string;
    texto2: string;
    textoSeleccionar: string;
    constructor(private servicePNotify: NotificationsService) { }

    ngOnInit() {
        this.texto1 = 'Arrastre el fichero';
        this.texto2 = 'o pulse aquí ';
        this.textoSeleccionar = 'Seleccionar fichero';
        this.uploader.onSuccessItem = this.onSuccessItem.bind(this);
        this.uploader.onErrorItem = this.onErrorItem.bind(this);
        this.uploader.onCancelItem = this.onCancelItem.bind(this);
        this.uploader.onWhenAddingFileFailed = this.onWhenAddingFileFailed.bind(this);

        this.uploader.onCompleteItem = this.onCompleteItem.bind(this);
        this.uploader.onAfterAddingFile = this.onAfterAddingFile.bind(this);
    }

    public fileOverBase(e: any): void {
        this.hasFileOver = e;
    }

    uploadItem(value: FileItem) {
        this.uploader.uploadItem(value);
    }

    cancelItem(value: FileItem) {
        this.uploader.cancelItem(value);
    }

    onAfterAddingFile(fileItem: FileItem): any {
        if (fileItem !== undefined) { this.toBase64(fileItem._file); }
    }

    toBase64(inputValue: any) {

        const file: File = inputValue;
        const myReader: FileReader = new FileReader();

        const self = this;
        myReader.onloadend = (e) => {
            this.valueChange.next({ base64: myReader.result, file: file});
        };

        myReader.readAsDataURL(file);
    }


    onFicheroGuardado(res: Response) {
        // Message.toast('Incidente cerrado correctamente', 'success');
        this.servicePNotify.success('ERROR', 'Fichero guardado correctamente');
        window.history.back();
    }

    onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
        const message = item.file.name + ' se ha subido al servidor corectamente';
        console.log(message);
        // Message.toast(message, 'success');
        this.servicePNotify.success('ERROR', message);
        this.onSuccess.emit(response);
    }

    onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
        const message = item.file.name + ' no se ha podido subir al servidor: ' + response;
        console.log(message);
        // Message.toast(message, 'error');
        this.servicePNotify.error('ERROR', message);
        this.onError.emit(response);
    }

    onCancelItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
        const message = 'Se ha cancelador la subida de ' + item.file.name;
        console.log(message);
        // Message.toast(message, 'warning');
        this.servicePNotify.warn('ERROR', message);
        this.onCancel.emit(response);
    }

    onWhenAddingFileFailed(item: FileLikeObject, filter: any, options: any): any {
        console.log('onWhenAddingFileFailed() ' + item.name + ' filter:' + filter + ' options:' + options);

        let reason = null;
        if (filter != null && filter.name === 'fileSize') {
            reason = item.name + ' es demasiado grande para subir al servidor (' + item.size + ' bytes)';
        } else {
            reason = item.name + ' no se puede subir: ' + filter.name;
        }

        if (reason != null) {
            // Message.toast(reason, 'error');
            this.servicePNotify.error('ERROR', reason);
        }

        this.onAddingFileFailed.emit(item);
    }

    onBeforeUploadItem(fileItem: FileItem): any {
        console.log('onBeforeUploadItem() ' + fileItem.file.name);
        this.uploading = true;
    }

    onCompleteItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
        console.log('onCompleteItem() ' + item.file.name + ' status:' + status + ' response:' + response);
        this.uploading = false;
    }

}



// WEBPACK FOOTER //
// ./src/app/utils/upload/upload.component.ts